/*
 * @Author:
 * @LastEditTime: 2022-03-28 19:15:52
 * @Description: 转换分页
 */
const transferSkipCount = (pageNo, pageSize) => {
  return (pageNo - 1) * pageSize
}

export { transferSkipCount }
